module.exports = {render: function () {with(this){return _c('svg',{staticClass:"ico-close",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50","width":"50","height":"50"}},[_c('circle',{staticClass:"st0",attrs:{"cx":"25","cy":"25","r":"25","id":"bg"}}),_c('path',{staticClass:"st1",attrs:{"d":"M36.3 15.1l-1.4-1.4-9.9 9.9-9.9-9.9-1.4 1.4 9.9 9.9-9.9 9.9 1.4 1.4 9.9-9.9 9.9 9.9 1.4-1.4-9.9-9.9z","id":"x"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./static/media/ico-close.svg
// module id = IQRm
// module chunks = 0